import {
    SECONDARY_HIGHLIGHT,
    PRIMARY_HIGHLIGHT,
    TERTIARY_HIGHLIGHT,
    PRIMARY,
    SECONDARY,
    TERTIARY,
    PRIMARY_XHIGHLIGHT,
    SECONDARY_XHIGHLIGHT,
    TERTIARY_XHIGHLIGHT,
    PRIMARY_2XDIM,
    SECONDARY_2XDIM,
    TERTIARY_2XDIM,
    PRIMARY_3XDIM,
    SECONDARY_3XDIM,
    TERTIARY_3XDIM,
    PRIMARY_4XDIM,
    SECONDARY_4XDIM,
    TERTIARY_4XDIM,
    MELOGY_WHITE,
    MELOGY_BLACK,
} from "../style/colors";

export const getButtonColor = (buttonColor, isSelected) => {
    if (buttonColor === "primary") {
        return isSelected ? PRIMARY_HIGHLIGHT : PRIMARY;
    } else if (buttonColor === "secondary") {
        return isSelected ? SECONDARY_HIGHLIGHT : SECONDARY;
    } else if (buttonColor === "tertiary") {
        return isSelected ? TERTIARY_HIGHLIGHT : TERTIARY;
    }

    if (buttonColor === "primary_dim") {
        return isSelected ? PRIMARY_3XDIM : PRIMARY_2XDIM;
    } else if (buttonColor === "secondary_dim") {
        return isSelected ? SECONDARY_3XDIM : SECONDARY_2XDIM;
    } else if (buttonColor === "tertiary_dim") {
        return isSelected ? TERTIARY_3XDIM : TERTIARY_2XDIM;
    }
    
    if (buttonColor === "white") {
        return MELOGY_WHITE;
    } else if (buttonColor === "black") {
        return MELOGY_BLACK;
    }

    return SECONDARY; // default
};

export const getButtonHoverColor = (buttonColor) => {
    switch (buttonColor) {
        case "primary":
            return PRIMARY_HIGHLIGHT;
        case "secondary":
            return SECONDARY_HIGHLIGHT;
        case "tertiary":
            return TERTIARY_HIGHLIGHT;
        case "primary_dim":
            return PRIMARY_3XDIM;
        case "secondary_dim":
            return SECONDARY_3XDIM;
        case "tertiary_dim":
            return TERTIARY_3XDIM;
        case "white":
            return MELOGY_WHITE;
        case "black":
            return MELOGY_BLACK;
        default:
            return SECONDARY_HIGHLIGHT; // default
    }
};

export const getButtonActiveColor = (buttonColor) => {
    switch (buttonColor) {
        case "primary":
            return PRIMARY_XHIGHLIGHT;
        case "secondary":
            return SECONDARY_XHIGHLIGHT;
        case "tertiary":
            return TERTIARY_XHIGHLIGHT;
        case "primary_dim":
            return PRIMARY_4XDIM;
        case "secondary_dim":
            return SECONDARY_4XDIM;
        case "tertiary_dim":
            return TERTIARY_4XDIM;
        case "white":
            return MELOGY_WHITE;
        case "black":
            return MELOGY_BLACK;
        default:
            return SECONDARY_XHIGHLIGHT; // default
    }
};
